import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-wizzard-success",
  templateUrl: "./wizzard-success.component.html",
  styleUrls: ["./wizzard-success.component.scss"],
  standalone: false,
})
export class WizzardSuccessComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
